// extracted by mini-css-extract-plugin
export var sliderRange = "_ce-2";
export var sliderRoot = "_ce-0";
export var sliderThumb = "_ce-3";
export var sliderTrack = "_ce-1";